import * as React from "react";

export default function Error({error}) {
    return (
        error !== 0 &&
        <p className="error">Achtung: Bitte überprüfen und vervollständigen Sie Ihre
            Angaben. </p>
    );
}
